import TYPES from './types';

import { IWarrantyError } from './reducers';
import warrantyService from 'src/services/warranty/WarrantyService';
import { IWarrantyProvider } from 'src/model/warranty.model';
import { IWarrantyCheck } from 'src/model/modules/warranty.model';

const setIsPending = (isPending: boolean) => {
  return {
    type: TYPES.SET_IS_PENDING,
    payload: isPending ? isPending : false
  };
};

const setError = (error?: IWarrantyError) => {
  return {
    type: TYPES.SET_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const setWarrantyProviders = (providers: IWarrantyProvider[]) => {
  return {
    type: TYPES.SET_WARRANTY_PROVIDERS,
    payload: providers
  };
};

const setWarrantyChecks = (checks: IWarrantyCheck[]) => {
  return {
    type: TYPES.SET_WARRANTY_CHECKS,
    payload: checks
  };
};

const getWarranty = () => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    warrantyService
      .getWarranties()
      .then(res => {
        dispatch(setWarrantyProviders(res.warrantyProviders));
        dispatch(setWarrantyChecks(res.warrantyChecks));
        dispatch(setIsPending(false));
      })
      .catch(err => {
        console.error(err);
        dispatch(setIsPending(false));
        dispatch(setError(err));
      });
  };
};

export default {
  setError,
  setIsPending,
  setWarrantyChecks,
  setWarrantyProviders,
  getWarranty
};
